import { render, staticRenderFns } from "./SubCategoryLayout.vue?vue&type=template&id=f8ff2088"
import script from "./SubCategoryLayout.vue?vue&type=script&lang=js"
export * from "./SubCategoryLayout.vue?vue&type=script&lang=js"
import style0 from "./SubCategoryLayout.vue?vue&type=style&index=0&id=f8ff2088&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports